/*
 *   File : send-mail.js
 *   Author : https://zappit.com
 *   Description : Send mail  modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import { Fragment, useEffect, useState } from 'react';

// custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';

// custom styles
import style from "../../Style/Components/modal.module.scss";
import CustomPhoneInput from '../FormElements/phone-input';
import service from '../../service';
import { toast } from 'react-toastify';
import { CustomTextInput } from '../FormElements';

const OpenAccountModal = (props) => {
    const params = new URLSearchParams(window.location.search);
    const orgId = params.get("org_id") || "";
    const emailValue = params.get("email") || "";
    const mobileNumber = params.get("mobile") || "";
    const countryCode = params.get("country_code") || "";

    const [phone, setPhone] = useState(mobileNumber ? mobileNumber.replace(/\s+/g, "") : "");
    const [phoneError, setPhoneError] = useState("");
    const [code, setCode] = useState(countryCode ? countryCode.replace(/\s+/g, "") : "");

    const [apiLoader, setApiLoader] = useState(false);
    const [userExists, setUserExists] = useState(false);

    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState("");
    const [otpScreen, setOtpScreen] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(mobileNumber);
    const [email, setEmail] = useState(emailValue);
    const [emailError, setEmailError] = useState("");


    useEffect(() => {
        setEmailError("");
    }, [email]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("open-account-modal-close");
        button.click();
        props.handleClose();
    };



    // handle confirm 
    const _handleUpdate = () => {
        let is_valid = true;
        // Email regex pattern
        const validate_email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


        if (email.trim().length === 0) {
            setEmailError("Email ID is required");
            is_valid = false;
        } else if (!validate_email.test(email)) {
            setEmailError("Please provide valid email");
            is_valid = false;
        }

        if (phoneNumber === "") {
            setPhoneError("Phone number is required");
            is_valid = false
        }
        if (phoneNumber !== "" && phoneNumber.length < 6) {
            setPhoneError("Invalid Phone number");
            is_valid = false
        }

        if (is_valid === true) {
            _registerUser();

        }
    };

    // handle confirm 
    const _handleValidateOtp = () => {
        let is_valid = true;
        // Email regex pattern

        if (otp === "") {
            setOtpError("OTP is required");
            is_valid = false
        }

        if (otp !== "" && otp.length < 6) {
            setOtpError("Invalid OTP");
            is_valid = false
        }
        if (is_valid === true) {
            _verifyOtp();

        }
    };

    function _handlePhone(value, data) {
        setPhone(value);
        setPhoneError("");
        const phone_value = value.slice(data.dialCode.length,)
        setPhoneNumber(phone_value);
        setCode(data.dialCode)
    }

    function _handleOtp(value) {
        if (value.length <= 6) {
            setOtp(value);
        }
        setOtpError("");
    }

    const _registerUser = async () => {
        setApiLoader(true);
        setOtp("");
        setOtpError("");
        const url = "user/auth/check-existence";

        const request = {
            mobile: `+${phone}`,
            org_id: orgId,
            email: email
        }

        const response = await service(false, url, request, null)
        toast.dismiss();
        if (response.status_code === 200) {
            if (response.active_user_exists === true) {
                setUserExists(true);
            } else {
                setOtpScreen(true);
            }

        } else {
            toast.error(response.message)
        }
        setApiLoader(false);
    }


    const _verifyOtp = async () => {
        setApiLoader(true);
        const url = "user/auth/verify-reg-otp";

        const request = {
            mobile: `+${phone}`,
            otp: otp,
            org_id: orgId,
            email: email
        }

        const details = {
            mobile_number: phoneNumber,
            code: `+${code}`,
            mobile: `+${phone}`
        }

        const response = await service(false, url, request, null)
        toast.dismiss();
        if (response.status_code === 200) {
            _handleCloseModal();
            props.handleConfirm(response.signup_progress, email);
            sessionStorage.setItem("user_key", response.user_key)
            sessionStorage.setItem("step", response.signup_progress)
            sessionStorage.setItem("details", JSON.stringify(details))

        } else {
            toast.error(response.message)
        }
        setApiLoader(false);
    }

    return (
        <div className="modal fade "
            id="open-account-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SendMailModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered ${props.type === 2 ? 'modal-lg' : style.e_send_mail_modal_width}  border-radius-28`}>
                <span id='open-account-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={` modal-content  border-radius-28  border-0`}>

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-3">
                        <h6 className='mb-0 color-white e-primary-font e-font-weight-500 e-font-16  line-height-100-percent'>
                            Open Account
                        </h6>

                    </div>

                    {
                        userExists ?
                            <Fragment>
                                <div className='modal-body pt-4 pb-0 padding-32px-lr'>
                                    <p className='mb-0 color-white e-primary-font e-font-weight-500 e-font-16 py-5 line-height-100-percent'>
                                        User with number already exist try with another number
                                    </p>
                                </div>
                                <div className='py-4 padding-32px-lr padding-32px-bottom px-3'>
                                    <div className='row'>
                                        <div className='col-6'>
                                            <SecondaryButton label="Close"
                                                data-bs-dismiss="modal"
                                                handleClick={_handleCloseModal} />
                                        </div>
                                        <div className='col-6'>
                                            <PrimaryButton label='Go Back'
                                                // loader={props.loader}
                                                handleClick={() => setUserExists(false)} />
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                            :

                            otpScreen === true ?
                                <Fragment>
                                    {/* Modal body */}
                                    <div className='modal-body pt-4 pb-0 padding-32px-lr'>

                                        <CustomTextInput type="number"
                                            value={otp}
                                            error={otpError}
                                            placeholder="Enter Email OTP"
                                            label="Enter Email OTP"
                                            required
                                            onKeyPress={_handleValidateOtp}
                                            handleChange={_handleOtp} />

                                    </div>

                                    {/* Modal footer */}
                                    <div className='py-4 padding-32px-lr padding-32px-bottom px-3 mt-2'>
                                        <div className='row'>
                                            <div className='col-6'>
                                                <SecondaryButton label="Back"
                                                    handleClick={() => {
                                                        setOtpScreen(false);
                                                        setUserExists(false)
                                                    }} />
                                            </div>
                                            <div className='col-6'>
                                                <PrimaryButton label='Verify OTP'
                                                    loading={apiLoader}
                                                    // loader={props.loader}
                                                    handleClick={_handleValidateOtp} />
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                                :
                                <Fragment>
                                    {/* Modal body */}
                                    <div className='modal-body pt-4 pb-0 padding-32px-lr'>
                                        <div className='d-flex flex-column gap-3'>
                                            <div>
                                                <label className={`${style.e_label} pb-2`}>
                                                    Enter number

                                                    <span className='color-carmine-pink'>*</span>

                                                </label>

                                                <CustomPhoneInput value={phone}
                                                    // disabled={mobileNumber !== "" ? true : false}
                                                    handleChange={_handlePhone}
                                                    error={phoneError}
                                                    wrapperClass="position-relative"
                                                    onSubmit={_handleUpdate} />
                                            </div>
                                            {/* <p className={'e-error-msg'}>
                                            {phoneError}
                                        </p> */}


                                            <CustomTextInput label="Email address"
                                                type="text"
                                                placeholder="Eg: example@gmail.com"
                                                required={true}
                                                value={email}
                                                disabled={emailValue ? true : false}
                                                error={emailError}
                                                onKeyPress={_handleUpdate}
                                                // handleChange={(e) => setEmail(e)}
                                                handleChange={(e) => setEmail(e.replace(/\s+/g, ''))}
                                            />

                                        </div>

                                    </div>

                                    {/* Modal footer */}
                                    <div className='py-4 padding-32px-lr padding-32px-bottom px-3 mt-2'>
                                        <div className='row'>
                                            <div className='col-6'>
                                                <SecondaryButton label="Cancel"
                                                    data-bs-dismiss="modal"
                                                    handleClick={_handleCloseModal} />
                                            </div>
                                            <div className='col-6'>
                                                <PrimaryButton label='Start'
                                                    loading={apiLoader}
                                                    // loader={props.loader}
                                                    handleClick={_handleUpdate} />
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                    }

                </div>
            </div>
        </div >
    )
}

export default OpenAccountModal;

OpenAccountModal.defaultProps = {
    handleClose: () => { },
    type: 1,
}